import useIntroStore from 'hooks/useIntroStore'
import { useStaff } from '../useSession'
import { resolveDevToggle, useDevToggles } from '../dev/useDevToggles'

const useIdleLogoutEnabled = () => {
  const staff = useStaff()
  const isIntroModal = useIntroStore((s) => s.mode !== 'none')
  const idleLogoutDev = useDevToggles((s) => s.idleLogout)

  // Always true if not in dev mode
  const idleLogout = resolveDevToggle(idleLogoutDev, true)

  if (!idleLogout) {
    return false
  }
  return !!staff || isIntroModal
}

export default useIdleLogoutEnabled
